/** Path after origin for office REST routes; keep aligned with bhapi-api. */
const OFFICE_V1_PATH = '/office/v1'

const env: any = process.env

/**
 * Endpoint and origin
 */
switch(env.NODE_ENV) {
  case 'staging':     env.ORIGIN = env.STA_ENDPOINT; break
  case 'development': env.ORIGIN = env.DEV_ENDPOINT; break
  default:            env.ORIGIN = env.PRO_ENDPOINT
}

if(env.ORIGIN) {
  env.ENDPOINT = `${env.ORIGIN}${OFFICE_V1_PATH}`
}

export default env
